module.exports = __webpack_public_path__ + "static/media/dashain1920x1080.69ecbfe8.png";